export default __webpack_public_path__ + "static/media/icon-tailwind.cb8046c1.svg";